export const colors = {
  // Neutral base — Supabase / Apple HIG system
  bg:          '#F8F9FA',   // page background
  bgAlt:       '#F0F0F0',   // sidebar rail + panel background
  surface:     '#FFFFFF',   // cards, panels, modals
  border:      '#E2E2E2',   // default border
  borderStrong:'#C8C8C8',   // emphasis border, dividers

  // Text scale
  text: {
    primary:     '#11181C',  // headings, primary content
    secondary:   '#3C4149',  // body text
    muted:       '#6B7280',  // secondary labels
    placeholder: '#9CA3AF',  // placeholders, group labels
    inverse:     '#FFFFFF',  // text on dark backgrounds
  },

  // KHĀVE brand — used in exactly 3 contexts:
  // 1. Primary action buttons
  // 2. Active nav indicator (icon + pill)
  // 3. KHĀVE wordmark / logo
  brand: {
    wine:      '#8B3144',   // primary accent
    wineDark:  '#6B2133',   // hover / pressed state
    wineLight: '#FCE3DC',   // badge backgrounds, subtle tints
  },

  // Semantic status colours — unchanged from previous sessions
  status: {
    complete:   '#059669',
    inProgress: '#3B82F6',
    onHold:     '#D97706',
    overdue:    '#DC2626',
    notStarted: '#6B7280',
    bankHoliday:'#94A3B8',
  },

  // Milestone type colours — unchanged
  milestone: {
    start:   '#22C55E',
    draft:   '#8B5CF6',
    review:  '#3B82F6',
    revision:'#F97316',
    signOff: '#DC2626',
    custom:  '#B45309',
  },

  // Status backgrounds (lighter tints for badges / pills)
  statusBg: {
    complete:    '#ECFDF5',
    inProgress:  '#EFF6FF',
    onHold:      '#FFFBEB',
    overdue:     '#FEF2F2',
    notStarted:  '#F3F4F6',
    bankHoliday: '#F1F5F9',
  },

  // Role badge colours
  role: {
    admin:  { bg: '#FCE3DC', text: '#8B3144' },
    editor: { bg: '#EFF6FF', text: '#1D4ED8' },
    viewer: { bg: '#F3F4F6', text: '#374151' },
  },
} as const;

export const spacing = {
  xs:   4,
  sm:   8,
  md:   12,
  lg:   16,
  xl:   20,
  xxl:  24,
  xxxl: 32,
} as const;

export const typography = {
  fontFamily: "'Montserrat', sans-serif",
  sizes: {
    xs:   9,
    sm:   10,
    base: 12,
    md:   13,
    lg:   16,
    xl:   20,
    xxl:  24,
  },
  weights: {
    regular:  400,
    medium:   500,
    semibold: 600,
    bold:     700,
    extrabold:800,
  },
  lineHeight: {
    tight:  1.3,
    normal: 1.5,
    relaxed:1.7,
  },
} as const;

export const radius = {
  sm:   4,
  md:   6,
  lg:   8,
  xl:   10,
  xxl:  12,
  full: 9999,
} as const;

export const shadow = {
  sm:  '0 1px 2px rgba(0,0,0,0.07)',
  md:  '0 2px 8px rgba(0,0,0,0.08)',
  lg:  '0 8px 24px rgba(0,0,0,0.10)',
  xl:  '0 12px 40px rgba(0,0,0,0.14)',
} as const;

export const breakpoints = {
  md:   1024,   // minimum supported
  lg:   1440,   // primary target (MacBook Pro 14/16)
  xl:   1920,   // secondary (external monitors)
} as const;

export const layout = {
  railWidth:      52,    // primary icon rail (px)
  sidebarWidth:   196,   // secondary nav panel (px)
  topbarHeight:   52,    // top bar (px)
  contentMaxWidth:1200,  // max content width at 1920 (px)
  contentPadding: 24,    // dashboard content padding (px)
} as const;
